import React from 'react';

export const QuickDepositIframe = React.lazy(() => import(/* webpackChunkName: "quick-deposit-iframe" */ './QuickDepositIframe'));

